import {
  GET_DETAIL_THUCHI,
  GET_DETAIL_THUCHI_SUCCESS,
  GET_DETAIL_THUCHI_FAILURE,
  POST_THANHTOAN_FAILURE,
  POST_THANHTOAN_SUCCESS,
  POST_THANHTOAN,
  DELETE_THANHTOAN_FAILURE,
  DELETE_THANHTOAN_SUCCESS,
  DELETE_THANHTOAN,
  UPDATE_OBJ_THANHTOAN,
  UPDATE_OBJVALUE_THANHTOAN,
  POST_THANHTOAN_ALL,
} from "./actionTypes";

export const getDetailThuChi = (dataSearch) => ({
  type: GET_DETAIL_THUCHI,
  dataSearch,
});

export const getDetailThuChiSuccess = (data) => ({
  type: GET_DETAIL_THUCHI_SUCCESS,
  payload: data,
});

export const getDetailThuChiFailure = () => ({
  type: GET_DETAIL_THUCHI_FAILURE,
});

export const postThanhToanChoVay = (dataPost, dataSearch) => ({
  type: POST_THANHTOAN,
  dataPost,
  dataSearch,
});
export const postThanhToanAllChoVay = (dataPost, dataSearch) => ({
  type: POST_THANHTOAN_ALL,
  dataPost,
  dataSearch,
});

export const postThanhToanChoVaySuccess = (data) => ({
  type: POST_THANHTOAN_SUCCESS,
  payload: data,
});

export const postThanhToanChoVayFailure = () => ({
  type: POST_THANHTOAN_FAILURE,
});

export const deleteThanhToanChoVay = (dataPost, dataSearch) => ({
  type: DELETE_THANHTOAN,
  dataPost,
  dataSearch,
});

export const deleteThanhToanChoVaySuccess = (data) => ({
  type: DELETE_THANHTOAN_SUCCESS,
  payload: data,
});

export const deleteThanhToanChoVayFailure = () => ({
  type: DELETE_THANHTOAN_FAILURE,
});
export const updateObjThanhToan = (data) => ({
  type: UPDATE_OBJ_THANHTOAN,
  payload: data,
});
export const updateValueObjThanhToan = (data) => ({
  type: UPDATE_OBJVALUE_THANHTOAN,
  payload: data,
});
